// const BASE_URL = process.env.REACT_APP_API_BASE || "https://api.mobielrijden.dev/app_dev.php/v4"
// const BASE_URL = process.env.REACT_APP_API_BASE || "http://192.168.3.23/v4"
const BASE_URL = process.env.REACT_APP_API_BASE || "https://api.test.mobielrijden.nl/v4"
const LIVENESS_WS_URL = process.env.REACT_APP_LIVENESS_WS_URL || "wss://liveness.kav2go.nl/ws/liveness"
const DISABLED_CACHE = true

export {BASE_URL, LIVENESS_WS_URL, DISABLED_CACHE}
